(function () {
  // Config
  const DEFAULT_MAX_QTY = 12;
  const WARNING_MS = 4000;

  let warningHideTimer = null;
  let atcRestoreTimer = null;
  let styleInjected = false;

  // Helpers
  function toInt(val, fallback) {
    const n = parseInt(val, 10);
    return Number.isFinite(n) ? n : fallback;
  }

  function getMaxQtyFromWarning(warningEl) {
    if (!warningEl) return DEFAULT_MAX_QTY;
    return toInt(warningEl.getAttribute('data-max'), DEFAULT_MAX_QTY);
  }

  // Find warning marker on product page
  function getProductFormWarning() {
    return (
      document.querySelector('product-form .max-qty-warning[data-variant-id]') ||
      document.querySelector('form[action*="/cart/add"] .max-qty-warning[data-variant-id]') ||
      null
    );
  }

  // Hide theme max qty message so only one warning is shown
  function hideThemeQtyError(scope) {
    const root = scope || document;

    const selectors = [
      '.product-form__error-message-wrapper',
      '.product-form__error-message',
      '[data-product-form-error-message]',
      '.form__message',
      '.shopify-error-message',
      '[role="alert"]'
    ];

    selectors.forEach(function (sel) {
      root.querySelectorAll(sel).forEach(function (el) {
        const txt = (el.textContent || '').toLowerCase();
        if (txt.indexOf('max quantity reached') !== -1) {
          el.hidden = true;
          el.style.display = 'none';
        }
      });
    });
  }

  // Suppress common success tick icons while showing the X
  function ensureAtcErrorStyle() {
    if (styleInjected) return;
    styleInjected = true;

    const style = document.createElement('style');
    style.type = 'text/css';
    style.textContent =
      '.max-qty-atc-error svg,' +
      '.max-qty-atc-error .icon,' +
      '.max-qty-atc-error [class*="icon"],' +
      '.max-qty-atc-error [aria-live],' +
      '.max-qty-atc-error [role="status"]{display:none !important;}' +
      '.max-qty-atc-x{display:inline-block !important;}';
    document.head.appendChild(style);
  }

  // Find nearest warning to the control being used
  function findNearestWarning(fromEl) {
    if (!fromEl) return document.querySelector('.max-qty-warning');

    const container =
      fromEl.closest('tr.cart-item') ||
      fromEl.closest('cart-item') ||
      fromEl.closest('[data-variant-id]') ||
      fromEl.closest('product-form') ||
      fromEl.closest('form') ||
      fromEl.closest('.product') ||
      document;

    return container.querySelector('.max-qty-warning') || document.querySelector('.max-qty-warning');
  }

  // Show warning and auto hide
  function showWarningTemporarily(fromEl) {
    const warning = findNearestWarning(fromEl);
    if (!warning) return;

    const scope =
      warning.closest('tr.cart-item') ||
      warning.closest('cart-item') ||
      warning.closest('product-form') ||
      warning.closest('form') ||
      document;

    hideThemeQtyError(scope);

    warning.hidden = false;

    if (warningHideTimer) window.clearTimeout(warningHideTimer);
    warningHideTimer = window.setTimeout(function () {
      warning.hidden = true;
      hideThemeQtyError(scope);
    }, WARNING_MS);
  }

  // Show red X when add is blocked due to cart already at max
  function showAddToCartErrorX() {
    const warning = getProductFormWarning();
    if (!warning) return;

    const scope =
      warning.closest('product-form') ||
      warning.closest('form') ||
      warning.closest('.product') ||
      document;

    const btn =
      scope.querySelector('button[name="add"]') ||
      scope.querySelector('button[type="submit"][name="add"]') ||
      scope.querySelector('button[type="submit"]');

    if (!btn) return;

    ensureAtcErrorStyle();

    if (!btn.dataset.maxQtyOriginalHtml) {
      btn.dataset.maxQtyOriginalHtml = btn.innerHTML;
    }

    if (atcRestoreTimer) window.clearTimeout(atcRestoreTimer);

    btn.classList.add('max-qty-atc-error');
    btn.classList.remove('is-added', 'added', 'success', 'loading');

    btn.innerHTML =
      '<span class="max-qty-atc-x" aria-hidden="true" style="color:#b00020;font-weight:700;font-size:18px;line-height:1;">✕</span>';

    atcRestoreTimer = window.setTimeout(function () {
      btn.classList.remove('max-qty-atc-error');
      if (btn.dataset.maxQtyOriginalHtml) {
        btn.innerHTML = btn.dataset.maxQtyOriginalHtml;
      }
    }, WARNING_MS);
  }

  // Quantity input discovery
  function findQtyInput(scope) {
    const root = scope || document;

    return (
      root.querySelector('input[name="quantity"]') ||
      root.querySelector('input.quantity__input') ||
      root.querySelector('input[data-quantity-input]') ||
      root.querySelector('quantity-input input') ||
      root.querySelector('input[type="number"]')
    );
  }

  // Warn on attempts even if UI clamps at max
  function bindAttemptWarning(qtyInput, plusBtn, maxQty) {
    if (!qtyInput) return;

    const boundKey = 'maxQtyAttemptBound_' + String(maxQty);
    if (qtyInput.dataset[boundKey]) return;
    qtyInput.dataset[boundKey] = '1';

    function currentVal() {
      const v = parseInt(qtyInput.value, 10);
      return Number.isFinite(v) ? v : null;
    }

    if (plusBtn) {
      const plusKey = 'maxQtyAttemptPlusBound_' + String(maxQty);
      if (!plusBtn.dataset[plusKey]) {
        plusBtn.dataset[plusKey] = '1';
        plusBtn.addEventListener('click', function () {
          const v = currentVal();
          if (v !== null && v >= maxQty) showWarningTemporarily(qtyInput);
        });
      }
    }

    qtyInput.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowUp') return;
      const v = currentVal();
      if (v !== null && v >= maxQty) showWarningTemporarily(qtyInput);
    });

    qtyInput.addEventListener('beforeinput', function (e) {
      if (!e || typeof e.inputType !== 'string') return;

      const type = e.inputType;
      const isText =
        type === 'insertText' ||
        type === 'insertFromPaste' ||
        type === 'insertReplacementText';

      if (!isText) return;

      const data = typeof e.data === 'string' ? e.data : '';
      const start =
        typeof qtyInput.selectionStart === 'number'
          ? qtyInput.selectionStart
          : qtyInput.value.length;
      const end =
        typeof qtyInput.selectionEnd === 'number'
          ? qtyInput.selectionEnd
          : qtyInput.value.length;

      const nextStr = qtyInput.value.slice(0, start) + data + qtyInput.value.slice(end);
      const nextVal = parseInt(nextStr, 10);

      if (Number.isFinite(nextVal) && nextVal > maxQty) {
        showWarningTemporarily(qtyInput);
      }
    });
  }

  // Product page clamp (only when warning marker exists)
  function bindLimit() {
    const warning = getProductFormWarning();
    if (!warning) return;

    const maxQty = getMaxQtyFromWarning(warning);

    const scope =
      warning.closest('product-form') ||
      warning.closest('form') ||
      warning.closest('.product') ||
      document;

    const qtyInput = findQtyInput(scope);
    if (!qtyInput) return;

    qtyInput.setAttribute('max', String(maxQty));

    const row = qtyInput.closest('.product-info__add-to-cart') || scope;

    const plusBtn =
      row.querySelector('[data-quantity-plus]') ||
      row.querySelector('.quantity__button[name="plus"]') ||
      row.querySelector('button[name="plus"]') ||
      row.querySelector('button[aria-label*="+"]');

    bindAttemptWarning(qtyInput, plusBtn, maxQty);

    function clampIfNeeded() {
      const val = parseInt(qtyInput.value, 10);
      if (!Number.isFinite(val)) return;

      if (val > maxQty) {
        qtyInput.value = String(maxQty);
        showWarningTemporarily(qtyInput);
        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    qtyInput.addEventListener('input', clampIfNeeded);
    qtyInput.addEventListener('change', clampIfNeeded);
    qtyInput.addEventListener('keyup', clampIfNeeded);
    qtyInput.addEventListener('blur', clampIfNeeded);

    if (plusBtn && !plusBtn.dataset.maxQtyPlusBound) {
      plusBtn.dataset.maxQtyPlusBound = '1';
      plusBtn.addEventListener('click', function () {
        window.setTimeout(function () {
          clampIfNeeded();
        }, 0);
      });
    }

    if (!row.dataset.maxQtyRowBound) {
      row.dataset.maxQtyRowBound = '1';
      row.addEventListener('click', function () {
        window.setTimeout(function () {
          clampIfNeeded();
        }, 0);
      });
    }

    clampIfNeeded();
  }

  // Cart and drawer clamp (rows must have data-max-qty and data-variant-id)
  function bindCartLimit() {
    const rows = document.querySelectorAll('tr.cart-item[data-max-qty][data-variant-id]');
    if (!rows.length) return;

    rows.forEach(function (row) {
      const rowMaxQty = toInt(row.getAttribute('data-max-qty'), DEFAULT_MAX_QTY);

      const boundKey = 'maxQtyCartBound_' + String(rowMaxQty);
      if (row.dataset[boundKey]) return;
      row.dataset[boundKey] = '1';

      const qtyInput = row.querySelector('input[name="updates[]"]');
      if (!qtyInput) return;

      qtyInput.setAttribute('max', String(rowMaxQty));

      const plusBtn =
        row.querySelector('button[name="plus"]') ||
        row.querySelector('[data-quantity-plus]') ||
        row.querySelector('.quantity__button[name="plus"]');

      bindAttemptWarning(qtyInput, plusBtn, rowMaxQty);

      function clampCart() {
        const val = parseInt(qtyInput.value, 10);
        if (!Number.isFinite(val)) return;

        if (val > rowMaxQty) {
          qtyInput.value = String(rowMaxQty);
          showWarningTemporarily(qtyInput);
          qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      qtyInput.addEventListener('input', clampCart);
      qtyInput.addEventListener('change', clampCart);
      qtyInput.addEventListener('keyup', clampCart);
      qtyInput.addEventListener('blur', clampCart);

      if (plusBtn && !plusBtn.dataset.maxQtyPlusCartBound) {
        plusBtn.dataset.maxQtyPlusCartBound = '1';
        plusBtn.addEventListener('click', function () {
          window.setTimeout(function () {
            clampCart();
          }, 0);
        });
      }

      clampCart();
    });
  }

  // Cart helpers
  function getCartJson() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  function cartQtyForVariant(cart, variantId) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    for (let i = 0; i < cart.items.length; i++) {
      const it = cart.items[i];
      if (it && it.id === variantId) return it.quantity || 0;
    }
    return 0;
  }

  // Prevent adding beyond max total in cart for the limited variant (only when warning marker exists)
  function bindAjaxAddCap() {
    const warning = getProductFormWarning();
    if (!warning) return;

    const maxQty = getMaxQtyFromWarning(warning);

    const variantIdAttr = warning.getAttribute('data-variant-id');
    const limitedVariantId = parseInt(variantIdAttr, 10);
    if (!Number.isFinite(limitedVariantId)) return;

    if (window.__maxQtyFetchWrapped) return;
    window.__maxQtyFetchWrapped = true;

    const originalFetch = window.fetch;

    window.fetch = function (input, init) {
      const url =
        typeof input === 'string'
          ? input
          : input && input.url
          ? input.url
          : '';

      const isAdd = url.indexOf('/cart/add') !== -1;
      if (!isAdd) return originalFetch.apply(this, arguments);

      init = init || {};
      const body = init.body;

      function parseAddBody() {
        if (!body) return { id: null, qty: 1 };

        if (body instanceof FormData) {
          const id = parseInt(body.get('id'), 10);
          const q = parseInt(body.get('quantity') || '1', 10);
          return { id: Number.isFinite(id) ? id : null, qty: Number.isFinite(q) ? q : 1 };
        }

        if (typeof body === 'string') {
          const params = new URLSearchParams(body);
          const id = parseInt(params.get('id'), 10);
          const q = parseInt(params.get('quantity') || '1', 10);
          return { id: Number.isFinite(id) ? id : null, qty: Number.isFinite(q) ? q : 1 };
        }

        if (body && typeof body === 'object') {
          const id = parseInt(body.id, 10);
          const q = parseInt(body.quantity || 1, 10);
          return { id: Number.isFinite(id) ? id : null, qty: Number.isFinite(q) ? q : 1 };
        }

        return { id: null, qty: 1 };
      }

      const parsed = parseAddBody();

      if (parsed.id !== limitedVariantId) {
        return originalFetch.apply(this, arguments);
      }

      return getCartJson().then(function (cart) {
        const existing = cartQtyForVariant(cart, limitedVariantId);
        const remaining = maxQty - existing;

        if (remaining <= 0) {
          showWarningTemporarily(warning);
          showAddToCartErrorX();
          hideThemeQtyError(document);

          return Promise.resolve(
            new Response(JSON.stringify({ ok: false, message: 'Max quantity reached' }), {
              status: 200,
              headers: { 'Content-Type': 'application/json' }
            })
          );
        }

        if (parsed.qty > remaining) {
          showWarningTemporarily(warning);
          hideThemeQtyError(document);
          parsed.qty = remaining;
        }

        if (body instanceof FormData) {
          body.set('quantity', String(parsed.qty));
          init.body = body;
        } else if (typeof body === 'string') {
          const params = new URLSearchParams(body);
          params.set('quantity', String(parsed.qty));
          init.body = params.toString();
        } else if (body && typeof body === 'object') {
          body.quantity = parsed.qty;
          init.body = body;
        }

        return originalFetch.call(this, input, init);
      });
    };
  }

  // Boot
  function boot() {
    bindLimit();
    bindCartLimit();
    bindAjaxAddCap();
    hideThemeQtyError(document);
  }

  document.addEventListener('DOMContentLoaded', boot);

  const mo = new MutationObserver(function () {
    boot();
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();